// extracted by mini-css-extract-plugin
export default {"gallery_item":"GalleryGrid_gallery_item__bP+li","media":"GalleryGrid_media__wd5hJ","gallery_grid":"GalleryGrid_gallery_grid__pT9iN"};